// Package Imports

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width="25"
    height="25"
    fill="none"
    stroke="currentColor"
    strokeWidth="4.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M36 14H20Q14 14 14 21V83Q14 89 20 89H69" />
    <path d="M64 14H80Q86 14 86 21V54" />
    <rect x="32" y="9" width="36" height="12" rx="4" />
    <circle cx="50" cy="35" r="7" fill="currentColor" />
    <path d="M38 51Q38 43 50 43Q62 43 62 51Z" />
    <path d="M25 60H54M25 70H48M25 80H41" />
    <circle cx="69" cy="69" r="19" fill="white" />
    <circle cx="69" cy="69" r="19" />
    <circle cx="69" cy="58" r="3.5" />
    <path d="M69 62C69 69 61 70 62 76C63 81 72 80 73 74" />
    <path d="M84 81V93M78 87H90" />
  </svg>
);

const HookRegistrationResource: ResourceItem = {
  name: resourceName.hookRegistration,
  identifier: ModuleIdentifierConst.HOOK_REGISTRATION,
  list: `${resourceName.hookRegistration}`,
  create: `${resourceName.hookRegistration}/create`,
  edit: `${resourceName.hookRegistration}/edit/:id`,
  show: `${resourceName.hookRegistration}/show/:id`,
  options: { label: 'Hook Registration', icon },
  meta: {
    label: 'Hook',
    icon,
    parent: resourceName.hook,
  },
};

export default HookRegistrationResource;
